<template>
    <div id="contendro-principal-intranet-plantilla">
        <!-- ENCABEZADOS -->
       <CHeader id="header-intranet" class=""></CHeader>
        <div id="contenedor-seccion-principal-intranet">
            <transition name="fade" mode="out-in">
                <router-view :key="$route.path"></router-view>
            </transition>
        </div>
        <!-- PIE DE PAGINA -->
        <CFooter></CFooter>
    </div>
</template>
<script>
import CHeader from "@/components/Intranet/Comun/Estructura/Header/CHeader.vue";
import CFooter from "@/components/Intranet/Comun/Estructura/Footer/CFooter.vue";

export default {
    components: {
        CHeader: CHeader,
        CFooter: CFooter
    },
    mounted() {
       /*  $(window).bind('scroll', function () {
            console.log('l::',$("#contendro-principal-intranet-plantilla").height())
            if ($(window).scrollTop() > 0) {
                $('#header-intranet').addClass('fixed-header-intranet');
            } else {
                $('#header-intranet').removeClass('fixed-header-intranet');
            }
        }); */
    },
}
</script>
<style scoped>

#contenedor-seccion-principal-intranet {
    background-color: #e6e6e6;
    /* min-height: calc(100vh - 103px); */
    min-height: calc(100vh - 30vmin);
    color: #111;
    padding-bottom: 2em;
}

.fixed-header-intranet {
    position:fixed;
    top:0;
    z-index: 9999999999999;
}
</style>


// WEBPACK FOOTER //
// src/components/Intranet/Comun/CPlantilla.vue